import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { CardFeedResponse } from 'src/queries/cardFeeds/cardFeeds.models'
import { fetchCardFeeds } from 'src/queries/cardFeeds/network/cardFeeds.network'
import {
  cardFeedsQueryKeys,
  queryCacheOptions,
} from 'src/queries/queries.constants'

const useQueryCardFeeds = (
  organizationId: string | undefined,
  enabled = true,
): UseQueryResult<CardFeedResponse[]> =>
  useQuery({
    queryKey: cardFeedsQueryKeys.list(organizationId),
    queryFn: async (): Promise<CardFeedResponse[]> => {
      const data = await fetchCardFeeds(organizationId as string)
      return data.cardFeeds
    },
    enabled: enabled && organizationId !== undefined,
    // The list page auto-redirects to the create flow when this resolves to an
    // empty array, so that decision must be made on freshly-fetched data — not
    // the 15-min-stale cache queryCacheOptions defaults to (refetchOnMount:
    // false). Always refetch on mount; CardFeeds additionally gates the
    // redirect on isFetchedAfterMount so it never acts on a prior visit's data.
    ...queryCacheOptions({ staleTime: 0 }),
    refetchOnMount: 'always',
  })

export default useQueryCardFeeds
